export const constants = {
    currency : 'SYP'
}